import { render } from "./SalePrint.vue?vue&type=template&id=23b5175c&scoped=true"
import script from "./SalePrint.vue?vue&type=script&lang=js"
export * from "./SalePrint.vue?vue&type=script&lang=js"

import "./SalePrint.vue?vue&type=style&index=0&id=23b5175c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b5175c"]])

export default __exports__